import React from "react";
import {
    Modal,
    Box,
    Text,
    Table,
    ScrollArea,
    Badge,
    Group,
    ThemeIcon,
    Stack,
    Divider,
} from "@mantine/core";
import { IconAlertTriangle, IconCheck, IconFileAlert, IconForms } from "@tabler/icons-react";
import { type IModalErroresCargaMasivaProps } from "../interfaces";

const ModalErroresCargaMasiva: React.FunctionComponent<IModalErroresCargaMasivaProps> = ({
    abrir,
    onClose,
    rechazadas,
    totales,
}) => {
    return (
        <Modal
            opened={abrir}
            onClose={onClose}
            styles={{
                header: { backgroundColor: '#0074d914' },
                body: { 
                    padding: 'var(--mantine-spacing-md)', 
                    paddingTop: 'var(--mantine-spacing-xs)', 
                    overflow: 'hidden'
                }
            }}
            title={
                <Group gap="xs">
                    <ThemeIcon color="primary" size="md" variant="light" radius="md">
                        <IconForms size={18} />
                    </ThemeIcon>
                    <Text fw={600} fz="md">Resumen de Carga Masiva</Text>
                </Group>
            }
            size="xl"
            radius="md"
            overlayProps={{
                backgroundOpacity: 0.55,
                blur: 3,
            }}
            zIndex={200000}
            centered
            scrollAreaComponent={Box}
        >
            <Stack gap="md" mt="xs">
                <Group grow gap="sm">
                    <Box
                        p="xs"
                        style={{
                            border: '1px solid var(--mantine-color-gray-2)',
                            borderRadius: 'var(--mantine-radius-md)',
                            backgroundColor: 'white',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <Group gap="xs">
                            <IconCheck size={16} color="#2f9e44" />
                            <Text size="xs" fw={500} c="dimmed">Guardadas</Text>
                        </Group>
                        <Text fz="sm" fw={700} c="green.7">{totales.guardadas}</Text>
                    </Box>

                    <Box
                        p="xs"
                        style={{
                            border: '1px solid var(--mantine-color-gray-2)',
                            borderRadius: 'var(--mantine-radius-md)',
                            backgroundColor: 'white',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <Group gap="xs">
                            <IconFileAlert size={16} color="#e03131" />
                            <Text size="xs" fw={500} c="dimmed">Rechazadas</Text>
                        </Group>
                        <Text fz="sm" fw={700} c="red.7">{totales.rechazadas}</Text>
                    </Box>
                </Group>

                {rechazadas.length > 0 && (
                    <Box style={{ minHeight: 0 }}>
                        <Divider label={<Text fz="xs" fw={500} c="dimmed">Detalle de Errores</Text>} labelPosition="center" mb="sm" />
                        
                        <Box style={{ border: '1px solid #dee2e6', borderRadius: 'var(--mantine-radius-sm)', overflow: 'hidden' }}>
                            <ScrollArea h={380} type="auto" scrollbarSize={8}>
                                <Table 
                                    verticalSpacing="xs" 
                                    horizontalSpacing="md" 
                                    withColumnBorders 
                                    stickyHeader
                                >
                                    <thead style={{ position: 'sticky', top: 0, zIndex: 10, background: '#f8f9fa', boxShadow: '0 1px 0 #dee2e6' }}>
                                        <Table.Tr>
                                            <Table.Th style={{ width: 80, fontSize: '11px', background: 'inherit' }}>Fila</Table.Th>
                                            <Table.Th style={{ width: 140, fontSize: '11px', background: 'inherit' }}>Código Equipo</Table.Th>
                                            <Table.Th style={{ fontSize: '11px', background: 'inherit' }}>Errores Encontrados</Table.Th>
                                        </Table.Tr>
                                    </thead>

                                    <Table.Tbody>
                                        {rechazadas.map((item, index) => (
                                            <Table.Tr key={index}>
                                                <Table.Td>
                                                    <Badge 
                                                        variant="light" 
                                                        color="primary" 
                                                        size="md" 
                                                        styles={{ 
                                                            root: { width: '100%', minWidth: '50px' },
                                                            label: { color: 'var(--mantine-color-dark-4)', fontSize: '11px', fontWeight: 700, overflow: 'visible' } 
                                                        }}
                                                    >
                                                        #{item.Fila}
                                                    </Badge>
                                                </Table.Td>
                                                <Table.Td>
                                                    <Text fz="xs" fw={700}>
                                                        {item.CodigoEquipo || "-"}
                                                    </Text>
                                                </Table.Td>
                                                <Table.Td>
                                                    <Stack gap={2}>
                                                        {item.Errores.map((error: string, eIndex: number) => (
                                                            <Group key={eIndex} gap={6} wrap="nowrap" align="flex-start">
                                                                <IconAlertTriangle size={12} color="var(--mantine-color-orange-6)" style={{ marginTop: 2, flexShrink: 0 }} />
                                                                <Text fz="xs" lh="xs" c="dark.3">{error}</Text>
                                                            </Group>
                                                        ))}
                                                    </Stack>
                                                </Table.Td>
                                            </Table.Tr>
                                        ))}
                                    </Table.Tbody>
                                </Table>
                            </ScrollArea>
                        </Box>
                    </Box>
                )}
            </Stack>
        </Modal>
    );
};

export default ModalErroresCargaMasiva;
